<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Notifications</h1>
          </div> -->
          <div class="col-sm-6">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Notifications</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-8">
            <div class="card">
              <div class="notification-details">
                <h3>Notifications</h3>
                <!-- <div class="notification-box new">
                  <h5>New <span class="badge">2</span></h5>
                  <ul>
                    <li>
                      <a href="#"
                        >We are working to resolve the issue. We sincerely
                        apologize for this temporary inconvenience.</a
                      >
                      <span>Sep 20 2023</span>
                    </li>
                    <li>
                      <a href="#"
                        >We are working to resolve the issue. We sincerely
                        apologize for this temporary inconvenience.</a
                      >
                      <span>Sep 20 2023</span>
                    </li>
                  </ul>
                </div> -->
                <div
                  class="notification-box"
                  v-for="(group, date) in groupWiseNotifications"
                  :key="'_index_' + date"
                >
                  <h5>{{ date }}</h5>
                  <ul>
                    <li v-for="(val, i) in group" :key="'_item_' + i">
                      <a :href="val.link.trim() == '' ? val.link : '#'">
                        {{ val.title }}
                      </a>
                      <span>{{ val.created_at }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-footer">
                <vue-pagination
                  :pagination="notifications"
                  v-if="notifications.total > notifications.per_page"
                  @paginate="getSystemNotifications()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { CommonAPI, SelfcareAPI } from "@/services/api";

export default {
  props: {
    //
  },
  computed: {},
  data: () => ({
    groupWiseNotifications: {},

    notifications: {
      is_loading: false,
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
      data: [],
    },
  }),
  mounted() {
    this.getSystemNotifications();
    console.log("Notification page");
  },
  methods: {
    // async getTicketNotifications() {
    //   // get_customer_ticket_notes
    //   let _this = this;
    //   let subscriber = localStorage.getItem("subscriber");
    //   subscriber = JSON.parse(subscriber);
    //   if (subscriber) {
    //     await SelfcareAPI.getTicketNotifications(subscriber.username)
    //       .then((response) => {
    //         _this.notifications.data = response;
    //         console.log("Response Data::", response);
    //         _this.notifications.is_loading = false;
    //       })
    //       .catch((error) => {
    //         console.log("Error::", error);
    //       })
    //       .finally(() => {
    //         _this.notifications.is_loading = false;
    //       });
    //   }
    // },

    async getSystemNotifications() {
      let _this = this;
      _this.notifications.is_loading = true;
      let query = { ..._this.filter, ..._this.$route.query };

      let subscriber = localStorage.getItem("subscriber");
      subscriber = JSON.parse(subscriber);
      if (subscriber) {
        await SelfcareAPI.getSystemNotifications(subscriber.username, query)
          .then((response) => {
            console.log("Notification Response::", response);
            _this.notifications = response;

            let groups = {};
            _this.notifications.data.forEach(function (val) {
              // var date = val.created_at.split("T")[0];
              let date = moment(val.created_at).format("DD/MM/YYYY");
              val.created_at = moment(val.created_at).format("MMM DD, YYYY");
              if (date in groups) {
                groups[date].push(val);
              } else {
                groups[date] = new Array(val);
              }
            });

            _this.groupWiseNotifications = groups;
            console.log("Notification Groups::", _this.groupWiseNotifications);

            _this.notifications.total = response.total;
            console.log("Response Data::", _this.notifications);
            _this.notifications.is_loading = false;
          })
          .catch((error) => {
            console.log("Error::", error);
          })
          .finally(() => {
            _this.notifications.is_loading = false;
          });
      }
    },
  },
};
</script>
